import { defineStore } from 'pinia'
import { showNotify } from 'vant'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    loading: false,
    loadingCount: 0,
    error: null,
    requestQueue: new Map(),
    needLogin: false
  }),

  actions: {
    showLoading() {
      this.loadingCount++
      if (this.loadingCount > 0) {
        this.loading = true
      }
    },

    setNeedLogin(value) {
      this.needLogin = value
    },

    hideLoading() {
      this.loadingCount = Math.max(0, this.loadingCount - 1)
      if (this.loadingCount <= 0) {
        this.loading = false
      }
    },

    resetLoading() {
      this.loadingCount = 0
      this.loading = false
    },

    setError(error) {
      this.error = error
    },

    clearError() {
      this.error = null
    },

    handleError(error) {
      this.setError(error)

      if (error.response && error.response.status === 401) {
        return
      }

      let errorMessage = '网络请求失败，请稍后重试'

      const errorCodeMap = {
        400: '请求参数错误',
        403: '您没有权限执行此操作',
        404: '请求的资源不存在',
        500: '服务器内部错误',
        502: '服务器连接失败',
        503: '服务器维护中',
      }

      if (error.response) {
        const status = error.response.status;
        const msg = error.response.data?.msg || ''
        errorMessage = msg || errorCodeMap[status] || `请求错误 (${status})`

      } else if (error.request) {
        errorMessage = '网络连接异常，请检查网络后重试'
      } else {
        errorMessage = error.message || '请求配置错误'
      }

      showNotify({ type: 'danger', message: errorMessage, duration: 3000 })
    },

    addRequest(requestId, cancelFunction) {
      this.requestQueue.set(requestId, cancelFunction)
    },

    cancelRequest(requestId) {
      if (this.requestQueue.has(requestId)) {
        const cancel = this.requestQueue.get(requestId)
        cancel && cancel('Request canceled by user')
        this.requestQueue.delete(requestId)
      }
    },

    cancelAllRequests() {
      for (const [requestId, cancel] of this.requestQueue) {
        cancel && cancel('All requests canceled')
      }
      this.requestQueue.clear()
    }
  }
})
